
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import { PageQuery } from '@/mixins/page_query';
import { eGenerateType, eRechargeType, eType, eVilidityDateType, iPromoteCode, iPromoteQuery } from '@/interface/promote-code';
import { exportPromoteAddThirdCode, exportPromoteUpdateThirdCodeDesc, getOldPromoteCodeList, updateOpen } from '@/api/promote-code';
import LogUtils from 'panda-log';
import Edit from '@/views/marketing/promote-code/components/edit.vue';
import { toast } from '@/utils/common';
import moment from 'moment';
import ThirdDialog from './third-dialog.vue';
@Component({
  components: { Edit, ThirdDialog },
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
})
export default class ExchangeCode extends Mixins(PageQuery) {
  @Prop({}) item: any;
  private visible = false;
  private loading = false;
  private title = '创建推广码';
  private tableData: iPromoteCode[] = [];
  private coin: eType = eType.COIN;
  private cloud: eType = eType.CLOUD;
  private weekcard: eType = eType.WEEKCARD;
  private cash: eType = eType.CASH;
  private thirdCode: eType = eType.THIRDCODE;
  private limit: eRechargeType = eRechargeType.LIMIT;
  private noLimit: eRechargeType = eRechargeType.NOLIMIT;
  private getDate: eVilidityDateType = eVilidityDateType.GETDATE;
  private rechargeTypeIndex: eRechargeType = this.noLimit; //充值类型
  private fixeDate: eVilidityDateType = eVilidityDateType.FIXEDATE;
  private vilidityDateIndex: eVilidityDateType = this.fixeDate; //领取时间方式
  private prebuilt: eGenerateType = eGenerateType.PREBUILT;
  private useGenerate: eGenerateType = eGenerateType.USEGENERATE;
  private thirdCoadVisible: boolean = false;
  private isUpload: boolean = false;
  private thridLoading: boolean = false;
  private errData: object | null = null;
  private newIntro: string = '';
  private model: iPromoteCode = {
    id: 0,
    name: '',
    expire_at: null,
    type: 1,
    number: 1,
    exchange_limit: null,
    gen_type: 1,
    extend: {
      amount: null,
      title: '',
      valid_days: 0,
      valid_start_ts: null,
      valid_end_ts: null,
      weekAmount: null,
      cashAmount: null,
      money_limit: null,
    },
  };
  private stateList = [
    { value: -1, lable: '请选择状态' },
    { value: 1, lable: '未兑换' },
    { value: 2, lable: '禁用' },
    { value: 3, lable: '已兑换' },
  ];
  private stateThirdList = [
    { value: -1, lable: '请选择状态' },
    { value: 1, lable: '未调用' },
    { value: 3, lable: '已调用' },
  ];
  private query: iPromoteQuery = {
    id: null,
    name: '',
    opr_name: '',
    pack_id: -1,
    status: -1,
    sequence: '',
  };
  handleCloseThirdCode() {
    this.thirdCoadVisible = false;
  }
  async handleThirdCodeCommit(value: any, isUpload: boolean) {
    try {
      this.thridLoading = true;
      if (isUpload) {
        //追加文件
        const params = new FormData();
        params.append('file', value.file);
        params.append('pack_id', this.item.id);
        let res = await exportPromoteAddThirdCode(params);
        this.openToast(res, isUpload);
      } else {
        //修改说明
        this.$msgbox({
          title: '提示',
          message: '是否确认修改!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              done();
              const data = { pack_id: this.item.id, intro: value };
              let res = await exportPromoteUpdateThirdCodeDesc(data);
              this.openToast(res, isUpload, value);
              instance.confirmButtonLoading = false;
            } else if (action === 'cancel') {
              done();
              instance.confirmButtonLoading = false;
            }
          },
        })
          .then(() => {})
          .catch((err: any) => {
            console.log(err);
          });
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.thridLoading = false;
    }
  }
  openToast(res: any, isUpload: boolean, value?: any) {
    const { code, msg } = res;
    if (code == 0) {
      let isSuccess = true;
      if (isUpload) {
        const { dup } = res.data;
        if (dup && dup.length > 0) {
          isSuccess = false;
          this.errData = res.data;
        }
      } else {
        this.newIntro = value; //给新的赋值
      }
      if (isSuccess) {
        toast(`操作成功`, 'success');
        this.handleCloseThirdCode();
      }
      this.getPromoteCodeTable();
    } else {
      toast(msg, 'error');
    }
  }
  openThirdCodeDialog(type: boolean) {
    this.thirdCoadVisible = true;
    this.isUpload = type;
    this.errData = null;
  }
  search() {
    this.page_query.page = 1;
    this.getPromoteCodeTable();
  }
  getState(state: number) {
    let item;
    if (this.item.type == this.thirdCode) {
      item = this.stateThirdList.filter(item => {
        return item.value == state;
      });
    } else {
      item = this.stateList.filter(item => {
        return item.value == state;
      });
    }

    if (item) {
      return item[0].lable;
    } else {
      return '-';
    }
  }
  @Emit() goback() {}

  handlerSuccess() {
    this.getPromoteCodeTable();
  }
  async getPromoteCodeTable() {
    try {
      this.loading = true;
      this.query.pack_id = this.item.id;
      const res = await getOldPromoteCodeList({ ...this.page_query, ...this.query });
      this.tableData = res.data.list;
      this.total = res.data.total;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  async switchCode(row: any) {
    try {
      const res = await updateOpen({ id: row.id, open: row.open });
      if (res.code == 0) {
        toast('操作成功!');
        this.getPromoteCodeTable();
      }
    } catch (error) {
      toast(error.msg, 'warning');
      LogUtils.debug(error);
    }
  }
  clear() {
    this.model = {
      id: 0,
      name: '',
      expire_at: null,
      type: 1,
      number: 1,
      exchange_limit: null,
      gen_type: 1,
      extend: {
        amount: null,
        title: '',
        valid_days: 0,
        valid_start_ts: null,
        valid_end_ts: null,
        weekAmount: null,
        cashAmount: null,
        money_limit: null,
      },
    };
  }

  mounted() {
    this.pageFn = this.getPromoteCodeTable;
    this.getPromoteCodeTable();
    if (this.item.type != this.thirdCode) {
      const money_limit = this.item.extend.money_limit;
      //是否限制金额
      if (money_limit && money_limit > 0) {
        this.rechargeTypeIndex = this.limit;
      } else {
        this.rechargeTypeIndex = this.noLimit;
      }

      //是否固定时间
      const validDays = this.item.extend.valid_days;
      if (validDays && validDays > 0) {
        this.vilidityDateIndex = this.getDate;
      } else {
        this.vilidityDateIndex = this.fixeDate;
      }
    } else {
      this.newIntro = this.item.intro;
    }
  }
}
